'use client';

import _slicedToArray from "/codebuild/output/src2869/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function getFloatingPosition(dir, position) {
  if (dir === "rtl" && (position.includes("right") || position.includes("left"))) {
    var _position$split = position.split("-"),
      _position$split2 = _slicedToArray(_position$split, 2),
      side = _position$split2[0],
      placement = _position$split2[1];
    var flippedPosition = side === "right" ? "left" : "right";
    return placement === void 0 ? flippedPosition : "".concat(flippedPosition, "-").concat(placement);
  }
  return position;
}
export { getFloatingPosition };